import React from 'react';
import c from 'classnames';
import EmptyState from './EmptyState';
import s from './SubscriptionCenter.scss';

export interface Props {
  moduleId: number;
  className?: string;
}

const SubscriptionCenter: React.FC<Props> = ({ className }) => (
  // We have no idea what this component may look like in the future, so just return the empty state
  <div className={c(s['root'], className)}>
    <EmptyState />
  </div>
);
SubscriptionCenter.displayName = 'SubscriptionCenter';

export default SubscriptionCenter;
